import { LoginComponent } from './pages/login/login.component';
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LandingPageComponent } from './pages/landing-page/landing-page.component';
import { PasswordResetPageComponent } from './pages/password-reset-page/password-reset-page.component';
import { SigninCallbackComponent } from './pages/signin-callback/signin-callback.component';
import { HomeComponent } from './home.component';


export const routes: Routes = [
    {
        path: '',
        component: HomeComponent
    },
    {
        path: 'signin-callback', 
        component: SigninCallbackComponent
    },
    {
        path: 'login',
        component: LoginComponent,
        data: {
            title: 'Login',
            navLabel: 'Login',
            navIcon: 'login'
        }
    },
    {
        path: 'landing-page',
        component: LandingPageComponent,
        data: {
            title: 'Landing',
            navLabel: 'Landing',
            navIcon: 'landing'
        }
    },
    {
        path: 'landing-page',
        loadChildren: () => import('./pages/landing-page/landing-page.module').then(m => m.LandingPageModule),
        data: {
            title: 'Landing',
            navLabel: 'Landing',
            navIcon: 'landing'
        }
    },
    {
        path: 'password-reset-page',
        component: PasswordResetPageComponent
    },
    {
        path: '**',
        redirectTo: '/landing-page',
        pathMatch: 'full'
    }
];

@NgModule({
    imports: [RouterModule.forRoot(routes)],
    exports: [RouterModule]
})
export class AppRoutingModule {}
